import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
export var env = _object_spread({}, process.env, window["env"]);
